export default {
  DURING_RECRUITMENT: "during_recruitment",
  CONTRACT_SEND: "contract_send",
  CONTRACT_SIGNED: "contract_signed",
  CONTRACT_DENIED: "contract_denied",
  COURSE_CANCELLED: "course_cancelled",
  CONTRACT_CANCELED: "contract_cancelled",
  NEEDED_TERMS_EDITION: "needed_terms_edition",
};
